import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './Sections.module.css';
import featureImg1 from '../Images/feature-img1.png';
import featureImg2 from '../Images/feature-img2.png';
function FeatureSection() {
  return (
    <div className={css.featureSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.featureInfo}>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg1} alt="" />
            </div>
            <div className={css.featureDetails}>
              <h3>
                <FormattedMessage id="OffsiteSuppliersPage.FeatureSection.closedPanelTitle" />
              </h3>
              <p>
                <FormattedMessage id="OffsiteSuppliersPage.FeatureSection.closedPanelDescription" />
              </p>
            </div>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg2} alt="" />
            </div>
            <div className={css.featureDetails}>
              <h3>
                <FormattedMessage id="OffsiteSuppliersPage.FeatureSection.modularTitle" />
              </h3>
              <p>
                <FormattedMessage id="OffsiteSuppliersPage.FeatureSection.modularDescription" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeatureSection;
